<script>
  import { ExternalLink } from 'lucide-svelte';

  export let href = '';

  $: safeHref = typeof href === 'string' ? href.trim() : '';
</script>

{#if safeHref}
  <div class="link-message">
    <a href={safeHref} target="_blank" rel="noopener noreferrer">
      <span>{safeHref}</span>
      <ExternalLink size={13} strokeWidth={2} />
    </a>
  </div>
{/if}

<style>
  .link-message {
    margin-top: 0.25rem;
  }

  .link-message a {
    display: inline-flex;
    align-items: center;
    gap: 0.32rem;
    max-width: min(22rem, 74vw);
    color: #075ecc;
    text-decoration: underline;
    text-underline-offset: 0.16rem;
  }

  .link-message span {
    min-width: 0;
    overflow-wrap: anywhere;
  }
</style>
